module.exports = __webpack_public_path__ + "img/photo-0065.11a213d6.jpg";